import React from "react";
import { useNavigate } from "react-router-dom";
import Men from "../assets/img/aqua-mahabalipuram/men.png";

export default function FocusSessionCard() {
  const navigate = useNavigate();

  // Data extracted for cleaner JSX
  const topics = [
    "Global Trade & Market Shifts",
    "Disease Mitigation",
    "Rethink Feed",
    "Turning the Tide Towards Domestic Market",
    "Product Diversification",
    "Innovations & New Technologies",
  ];

  const handleNavigate = () => {
    navigate("/programs");
  };

  return (
    <div className="w-full max-w-5xl mx-auto bg-gradient-to-r from-cyan-200 via-teal-100 to-blue-100 my-10 p-6 md:p-8 rounded-lg shadow-lg">
      {/* Flex Container: 
               - flex-col: Stacks items vertically on mobile
               - md:flex-row: Puts items side-by-side on tablet/desktop
            */}
      <div className="flex flex-col md:flex-row justify-between items-start gap-8 md:gap-12">
        {/* Left Section - Focus Topics */}
        <div className="w-full md:flex-1">
          <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center md:text-left">
            Focus Session:
          </h2>

          <div className="space-y-4">
            {topics.map((topic, index) => (
              <div
                key={index}
                className={`border-gray-300 pb-3 ${
                  index !== topics.length - 1 ? "border-b-2" : ""
                }`}
              >
                <h3 className="text-lg md:text-xl font-semibold text-gray-700">
                  {topic}
                </h3>
              </div>
            ))}
          </div>
        </div>

        {/* Right Section - Keynote Speaker */}
        {/* - w-full: Full width on mobile
                   - max-w-sm: Stops it from getting too big on tablets
                   - md:w-72: Fixed width on desktop
                */}
        <div className="w-full max-w-sm mx-auto md:w-72 md:mx-0 bg-gradient-to-b from-cyan-300 to-cyan-200 p-6 rounded-lg flex-shrink-0">
          <h3 className="text-lg font-bold text-gray-800 mb-4 text-center">
            Keynote Speaker
          </h3>

          <div className="bg-gray-100 rounded-lg mb-4 overflow-hidden">
            <img
              src={Men}
              alt="Robins McIntosh"
              className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-300"
            />
          </div>

          <div className="text-center">
            <h4 className="text-lg font-bold text-gray-800 mb-2">
              Robins McIntosh
            </h4>
            <p className="text-sm text-gray-700 leading-relaxed">
              Executive Vice President,
              <br />
              Charoen Pokphand Foods,
              <br />
              Thailand.
            </p>
          </div>
        </div>
      </div>

      {/* View All Programs Button - Centered Below Both Sections */}
      <div className="mt-8 flex justify-center">
        <button
          onClick={handleNavigate}
          className="bg-cyan-600 hover:bg-cyan-700 text-white font-semibold py-3 px-8 rounded-lg transition-colors duration-300 shadow-md hover:shadow-lg"
        >
          View All Programs
        </button>
      </div>
    </div>
  );
}
